import { fromJS } from 'immutable';
import * as repo from './repo'

let initialState = fromJS({
    
});

function initState() {
    // Check for language cookie
    let lang = document.cookie.match("lang=(.*?)(?=(;| ))");
    if (lang != null && lang[1]){
        initialState = initialState.set("language", lang[1])
    }
    return initialState;
}

export const ACTION_FIELD_SET = "field-set"

function reduce (state = initState(), action)
{
    switch (action.type) {
    case ACTION_FIELD_SET:
        if (!repo.Fields[action.fieldId]) {throw "Field not defined: " + action.fieldId;}
        return repo.Fields[action.fieldId].set(state, action.fieldValue)
    default:
        return state
    }
}

export default reduce
